import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Spinner from "../../../components/spinner";
import Pagination from "../../../components/elements/pagination";
import Loader from "../../../components/loader";
import useTestimonialList from "../../../hooks/testimonial/useTestimonialList";
import Errors from "../../../pages/errors"; // Adjust import path if needed
import AddTestimonial from "./AddTestimonial";
import UpdateTestimonial from "./UpdateTestimonial";
import DeleteTestimonial from "./DeleteTestimonial";
import SwitchToggle from "../../../components/elements/switchtoggle/SwitchToggle";

function Testimonials() {
    const {
        data,
        paramsObject,
        testimonialId,
        selectedTestimonial,
        openAddModal,
        isOpenEditModal,
        openDeleteModal,
        handleSearchVal,
        handlePageClick,
        handleOpenAddModal,
        handleOpenEditModal,
        handleOpenDeleteModal,
        handleModalClose,
        handleDeleteSuccess,
        testimonialStatus,
        isToggleLoading,
        handleTestimonialStatusChange,
        header,
        handleHeaderChange,
        handleSaveHeader,
        isHeaderUpdating,
        isHeaderChanged,
    } = useTestimonialList();

    return (
        <>
            <div className="testimonials px-4">
                <div className="blog__head headingBorder__b">
                    <h2 className="titleHeading">Testimonials</h2>
                </div>
                <div className="blog_table py-5 space-y-5">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center">
                            <SwitchToggle
                                label="Enable Testimonials"
                                name="testimonialStatus"
                                checkedValue={testimonialStatus}
                                onChange={handleTestimonialStatusChange}
                                className="mr-2"
                            />
                            {isToggleLoading && <Loader className="text-blue-500 h-4 w-4 ml-2" />}
                        </div>

                        <div className="flex items-center gap-4 flex-1 justify-end">
                            <div className="max-w-md w-full">
                                <label className="label block mb-1">Header</label>
                                <input
                                    type="text"
                                    className="input"
                                    value={header}
                                    onChange={handleHeaderChange}
                                    placeholder="Testimonial Header"
                                />
                            </div>
                            <div className="mt-6">
                                <Button
                                    variant="contained"
                                    onClick={handleSaveHeader}
                                    disabled={!isHeaderChanged || isHeaderUpdating}
                                    className="primaryBtn-contained"
                                >
                                    <div className="flex items-center gap-2">
                                        {isHeaderUpdating && <Loader className="h-4 w-4" />}
                                        Save
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center space-x-4">
                        <div className="flex-1">
                            <input
                                onChange={handleSearchVal}
                                value={paramsObject?.search_query || ""}
                                type="text"
                                name="search_query"
                                placeholder="Search Testimonials...."
                                className="input"
                            />
                        </div>
                        <div onClick={handleOpenAddModal}>
                            <Button
                                variant="outlined"
                                startIcon={<AddIcon />}
                                className="primaryBtn-outlined"
                            >
                                Create Testimonial
                            </Button>
                        </div>
                    </div>

                    {data?.isLoading ? (
                        <Spinner />
                    ) : data?.status === "error" ? (
                        <Errors errorObject={data.error} inline />
                    ) : (
                        <>
                            <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
                                <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                                    <thead>
                                        <tr className="text-left">
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                Sr.no
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Image
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Name
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Designation / Company
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Content
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Status
                                            </th>
                                            <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.data?.data?.length > 0 ? (
                                            data?.data?.data?.map((item, idx) => {
                                                const { name, designation_company, content, image, active, testimonial_id } = item;
                                                return (
                                                    <tr key={idx}>
                                                        <td className="border-dashed border-t border-gray-200 userId">
                                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                                                                {paramsObject.limit * +paramsObject.page_number + idx + 1}
                                                            </span>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200">
                                                            <div className="flex justify-center">
                                                                {image ? (
                                                                    <img src={image} alt={name} className="w-10 h-10 object-cover" />
                                                                ) : (
                                                                    <span className="text-xs text-gray-400">No Img</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200 firstName">
                                                            <span className="text-gray-700 px-6 py-3 text-center block text-sm">
                                                                {name}
                                                            </span>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200 firstName">
                                                            <span className="text-gray-700 px-6 py-3 text-center block text-sm">
                                                                {designation_company}
                                                            </span>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200 firstName">
                                                            <span className="text-gray-700 px-6 py-3 text-center block text-sm max-w-xs truncate" title={content}>
                                                                {content.length > 50 ? content.substring(0, 50) + "..." : content}
                                                            </span>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200 emailAddress">
                                                            <div className="flex items-center justify-center">
                                                                {active === "1" ? (
                                                                    <span className="px-4 py-1 font-semibold rounded bg-green-700 text-green-200">
                                                                        Active
                                                                    </span>
                                                                ) : (
                                                                    <span className="px-4 py-1 font-semibold rounded bg-gray-400 text-white">
                                                                        Inactive
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="border-dashed border-t border-gray-200 phoneNumber">
                                                            <div className="flex items-center space-x-5 justify-center">
                                                                <div>
                                                                    <IconButton
                                                                        onClick={() => handleOpenEditModal(item)}
                                                                    >
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </div>
                                                                <div onClick={() => handleOpenDeleteModal(testimonial_id)}>
                                                                    <IconButton>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className="text-center py-5 text-gray-500">
                                                    No Testimonials Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="my-7">
                                <Pagination
                                    currentPage={+paramsObject.page_number}
                                    lengthofItems={data?.data?.total_count}
                                    limit={paramsObject.limit}
                                    onPageChange={handlePageClick}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>

            <AddTestimonial open={openAddModal} handleClose={handleModalClose} />
            <UpdateTestimonial
                testimonialData={selectedTestimonial}
                open={isOpenEditModal}
                handleClose={handleModalClose}
            />
            <DeleteTestimonial
                open={openDeleteModal}
                onClose={handleModalClose}
                testimonial_id={testimonialId}
                onDelete={handleDeleteSuccess}
            />

        </>
    );
}

export default Testimonials;
